
import React from 'react';
import { ShieldCheck, Loader2 } from 'lucide-react';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-brand-950 overflow-hidden">
      {/* Background Decorative Element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      
      <div className="relative flex flex-col items-center gap-10 animate-in fade-in duration-700">
        <div className="relative flex items-center justify-center w-32 h-32">
          {/* Rotating Ring */}
          <div className="absolute inset-0 rounded-full border-t-2 border-r-2 border-primary/40 animate-spin duration-[2000ms]"></div>
          <div className="absolute inset-4 rounded-full border-b-2 border-l-2 border-primary/20 animate-spin-reverse duration-[3000ms]"></div>
          
          {/* Core Icon */}
          <div className="w-16 h-16 rounded-3xl bg-primary/10 flex items-center justify-center border border-primary/20 shadow-[0_0_30px_rgba(234,179,8,0.1)]">
              <span className="text-primary font-display font-black text-3xl">O</span>
          </div>
        </div>

        <div className="text-center space-y-3">
          <div className="flex items-center justify-center gap-3 text-primary/60">
            <ShieldCheck size={16} />
            <p className="text-[10px] font-black uppercase tracking-[0.5em]">Segurança OBPC</p>
          </div>
          <h2 className="text-white font-display font-black text-xl uppercase tracking-tighter">Sincronizando Identidade</h2>
          <p className="text-slate-600 text-[9px] font-bold uppercase tracking-[0.3em] max-w-[200px] mx-auto leading-relaxed">
            Verificando sessão ativa no ecossistema digital...
          </p>
        </div>

        <div className="flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/10 rounded-full">
           <Loader2 size={14} className="animate-spin text-slate-500" />
           <span className="text-[8px] font-black text-slate-500 uppercase tracking-widest">Iniciando Protocolos</span>
        </div>
      </div>

      {/* Footer text */}
      <div className="absolute bottom-12 text-center opacity-20">
         <p className="text-[8px] font-black text-white uppercase tracking-[1em]">Familia OBPC SSOT</p>
      </div>
    </div>
  );
};
